<mat-progress-bar class="app-orion-page-loader" color="warn" mode="indeterminate" value="50">
</mat-progress-bar>